module.exports = __webpack_public_path__ + "img/bg-3.b7bf9eb1.svg";